import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import useStyles from "./InputWrapper.styles";
import useRecall from "../../hooks/useRecall";

export default function InputWrapper({
    size,
    leftLabel,
    rightLabel,
    children,
}: {
    size?: any;
    leftLabel?: string;
    rightLabel?: string;
    children: any;
}) {
    const theme = useTheme();
    const classes = useStyles({ theme, size });
    const leftRecalledLabel = useRecall(leftLabel);
    const rightRecalledLabel = useRecall(rightLabel);

    return (
        <div className={classes.inputWrapper}>
            {leftRecalledLabel && (
                <span
                    className={classnames(classes.inputWrapperLabel, classes.inputWrapperLabelLeft)}
                    dangerouslySetInnerHTML={{ __html: leftRecalledLabel }}
                />
            )}
            <div className={classes.inputWrapperControl}>{children}</div>
            {rightRecalledLabel && (
                <span
                    className={classnames(
                        classes.inputWrapperLabel,
                        classes.inputWrapperLabelRight,
                    )}
                    dangerouslySetInnerHTML={{ __html: rightRecalledLabel }}
                />
            )}
        </div>
    );
}
